var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pi-ai-text"},[_vm._l((_vm.segments),function(segment){return [(segment.strong)?_c('strong',{key:segment.key},[_vm._v(_vm._s(segment.text))]):(segment.code)?_c('code',{key:segment.key,staticClass:"pi-ai-text__code"},[_vm._v(_vm._s(segment.text))]):_c('span',{key:segment.key},[_vm._v(_vm._s(segment.text))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55b56a90","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/pi/piAssistantText.vue
// module id = 1836
// module chunks = 0